import { clsx, type ClassValue } from 'clsx';

/** Join class names conditionally (thin wrapper over clsx so components share one import). */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
